import angular from 'angular';

angular.module("core.application.main").filter("core_application_main_filter_orderStatus", function() {
    // convert the backend order statuses into the front presentation
    return function (input) {
        var orderStatuses = {
            APPROVED: "general:status-approved",
            DECLINED: "general:status-declined",
            FAILED: "general:status-failed",
            INCOMPLETE: "general:status-incomplete"
        };
        return orderStatuses[input] || "general:status-unknown";
    };
});
